import {
  CreateInstanceRequest,
  CreateInstanceResponse,
  GetInstanceResponse,
  ReconnectInstanceRequest,
} from "@/types/instanceTypes";
import {createApi, FetchArgs} from "@reduxjs/toolkit/query/react";
import platformAuthConfig from "./platformConfig";

export type TagTypes = "Instances";

const instancesApi = createApi({
  reducerPath: "instancesApi",
  ...platformAuthConfig(),
  tagTypes: ["Instances"],
  endpoints: (builder) => ({
    createInstance: builder.mutation<
      CreateInstanceResponse,
      CreateInstanceRequest
    >({
      query: (config): FetchArgs => ({
        url: `/${config.org_id}/instances/create_connection`,
        method: "POST",
        body: config,
      }),
      invalidatesTags: ["Instances"],
    }),
    reconnectInstance: builder.mutation<
      CreateInstanceResponse,
      ReconnectInstanceRequest
    >({
      query: (config): FetchArgs => ({
        url: `/${config.org_id}/instances/reconnect_account`,
        method: "POST",
        body: config,
      }),
      invalidatesTags: ["Instances"],
    }),
    getInstances: builder.query<GetInstanceResponse, string>({
      query: (org_id): FetchArgs => ({
        url: `/${org_id}/instances/list_connections`,
        method: "GET",
      }),
      providesTags: ["Instances"],
    }),
    deleteInstance: builder.mutation<void, ReconnectInstanceRequest>({
      query: (config): FetchArgs => ({
        url: `/${config.org_id}/instances/connected_accounts/${config.reconnect_account_id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Instances"],
    }),
  }),
});

export const {
  useCreateInstanceMutation,
  useGetInstancesQuery,
  useReconnectInstanceMutation,
  useDeleteInstanceMutation,
} = instancesApi;

export default instancesApi;
